import React from 'react';
import { Route, Switch } from 'react-router-dom';
import {
  COMPANY_RESOURCE_GROUP_PATH,
  COMPANY_RESOURCE_PATH,
  NEW_COMPANY_RESOURCE_GROUP_PATH,
  NEW_COMPANY_RESOURCE_PATH,
  NEW_PREVENTIVE_TASK_ASSIGNEE_PATH,
  NEW_PREVENTIVE_TASK_EXECUTION_PATH,
  NEW_PREVENTIVE_TASK_PATH,
  PREVENTIVE_TASK_ASSIGNEE_PATH,
  PREVENTIVE_TASK_EXECUTION_PATH,
  PREVENTIVE_TASK_PATH,
  PREVENTIVE_TASK_PROJECTION_PATH,
  TASK_SCHEDULE_PATH,
} from '../../../config/paths';
import TaskScheduleHome from './TaskScheduleHome';
import PreventiveTasks from './preventive-task/PreventiveTasks';
import NewPreventiveTask from './preventive-task/NewPreventiveTask';
import PreventiveTask from './preventive-task/PreventiveTask';
import EditPreventiveTask from './preventive-task/EditPreventiveTask';
import PreventiveTaskAssignees from './preventive-task-asignee/PreventiveTaskAssignees';
import NewPreventiveTaskAssignee from './preventive-task-asignee/NewPreventiveTaskAssignee';
import PreventiveTaskAssignee from './preventive-task-asignee/PreventiveTaskAssignee';
import EditPreventiveTaskAssignee from './preventive-task-asignee/EditPreventiveTaskAssignee';
import NewPreventiveTaskExecution from './preventive-task-execution/NewPreventiveTaskExecution';
import PreventiveTaskExecution from './preventive-task-execution/PreventiveTaskExecution';
import PreventiveTaskProjectionCalendar from './preventive-task-projection/PreventiveTaskProjectionCalendar';
import CompanyResources from './company-resource/CompanyResources';
import NewCompanyResource from './company-resource/NewCompanyResource';
import EditCompanyResource from './company-resource/EditCompanyResource';
import CompanyResource from './company-resource/CompanyResource';
import CompanyResourceGroup from './company-resource-group/CompanyResourceGroup';
import CompanyResourceGroups from './company-resource-group/CompanyResourceGroups';
import NewCompanyResourceGroup from './company-resource-group/NewCompanyResourceGroup';
import EditCompanyResourceGroup from './company-resource-group/EditCompanyResourceGroup';
import PreventiveTaskExecutionHistory from './preventive-task-execution-history/PreventiveTaskExecutionHistory';

const TaskScheduleUnit = () => (
  <Switch>
    <Route exact path={TASK_SCHEDULE_PATH} component={TaskScheduleHome} />
    <Route exact path={COMPANY_RESOURCE_PATH} component={CompanyResources} />

    <Route
      exact
      path={NEW_COMPANY_RESOURCE_PATH}
      component={NewCompanyResource}
    />

    <Route
      exact
      path={`${COMPANY_RESOURCE_PATH}/:id`}
      component={CompanyResource}
    />
    <Route
      exact
      path={`${COMPANY_RESOURCE_PATH}/:id/edit`}
      component={EditCompanyResource}
    />

    <Route
      exact
      path={COMPANY_RESOURCE_GROUP_PATH}
      component={CompanyResourceGroups}
    />

    <Route
      exact
      path={NEW_COMPANY_RESOURCE_GROUP_PATH}
      component={NewCompanyResourceGroup}
    />

    <Route
      exact
      path={`${COMPANY_RESOURCE_GROUP_PATH}/:id`}
      component={CompanyResourceGroup}
    />
    <Route
      exact
      path={`${COMPANY_RESOURCE_GROUP_PATH}/:id/edit`}
      component={EditCompanyResourceGroup}
    />
    <Route exact path={PREVENTIVE_TASK_PATH} component={PreventiveTasks} />
    <Route
      exact
      path={NEW_PREVENTIVE_TASK_PATH}
      component={NewPreventiveTask}
    />
    <Route
      exact
      path={`${PREVENTIVE_TASK_PATH}/:id`}
      component={PreventiveTask}
    />
    <Route
      exact
      path={`${PREVENTIVE_TASK_PATH}/:id/edit`}
      component={EditPreventiveTask}
    />
    <Route
      exact
      path={PREVENTIVE_TASK_ASSIGNEE_PATH}
      component={PreventiveTaskAssignees}
    />
    <Route
      exact
      path={NEW_PREVENTIVE_TASK_ASSIGNEE_PATH}
      component={NewPreventiveTaskAssignee}
    />
    <Route
      exact
      path={`${PREVENTIVE_TASK_ASSIGNEE_PATH}/:id`}
      component={PreventiveTaskAssignee}
    />
    <Route
      exact
      path={`${PREVENTIVE_TASK_ASSIGNEE_PATH}/:id/edit`}
      component={EditPreventiveTaskAssignee}
    />
    <Route
      exact
      path={PREVENTIVE_TASK_EXECUTION_PATH}
      component={PreventiveTaskExecutionHistory}
    />
    <Route
      exact
      path={NEW_PREVENTIVE_TASK_EXECUTION_PATH}
      component={NewPreventiveTaskExecution}
    />
    <Route
      exact
      path={`${PREVENTIVE_TASK_EXECUTION_PATH}/:id`}
      component={PreventiveTaskExecution}
    />
    <Route
      exact
      path={PREVENTIVE_TASK_PROJECTION_PATH}
      component={PreventiveTaskProjectionCalendar}
    />
  </Switch>
);

export default TaskScheduleUnit;
